import React, { useRef, useState, useEffect, useCallback } from "react";
import styles from "./styles.module.css";
import cx from "classnames";

function useOnClickOutside(ref, handler) {
  useEffect(() => {
    const listener = (event) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);
    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);
}

const ExpertCard = ({ expert }) => {
  const [isShown, setIshown] = useState(false);
  const [isTouchable, setIsTouchable] = useState(false);

  useEffect(() => {
    // Do after SSR
    setIsTouchable(window.navigator.maxTouchPoints > 0);
  }, []);

  const expertRef = useRef(null);
  useOnClickOutside(expertRef, () => {
    if (isTouchable) {
      setIshown(false);
    }
  });

  const onClicked = useCallback(() => {
    if (isTouchable) {
      setIshown((prevState) => !prevState);
    }
  }, [isTouchable]);

  return (
    <div
      ref={expertRef}
      className={cx(styles.slide, !isTouchable && styles.hoverable)}
      onClick={onClicked}
    >
      <div
        className={cx(
          styles.slideInner,
          styles.animation,
          isTouchable && isShown && styles.isShown
        )}
      >
        <div className={styles.activeSlideObverse}>
          <div className={styles.flex}>
            <p className={styles.job}>{expert.intro}</p>
            <img alt="Фото эксперта" src={expert.photo.file.url} />
          </div>
          <div className={styles.footer}>
            <p className={styles.company}>{expert.company}</p>
            <p className={styles.name}>{expert.expertName}</p>
          </div>
        </div>
        <div className={styles.activeSlideRevers}>
          <div className={styles.slideReversHederWrapper}>
            <div className={styles.activeSlideTitle}>Об эксперте</div>
            <div>
              <div className={styles.activeSlideTwitter}>
                {expert.twitter && (
                  <a
                    href={`https://twitter.com/${expert.twitter}`}
                    target="_blank"
                  >
                    @{expert.twitter}
                  </a>
                )}
              </div>
            </div>
          </div>
          <div className={styles.activeSlideText}>{expert.desc.desc}</div>
        </div>
      </div>
    </div>
  );
};

export default ExpertCard;
